import thunkMiddleware from 'redux-thunk';
import {apiMiddleware} from 'redux-api-middleware';
import {createStore, applyMiddleware, compose} from 'redux';
import {rootReducer} from '../modules/rootReducer';

const initialState = {};

const middleware = [thunkMiddleware, apiMiddleware];
const middlewareEnhancer = applyMiddleware(...middleware);
const enhancers = [middlewareEnhancer];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(...enhancers);

const store = createStore(rootReducer, initialState, composedEnhancers);

export default store;
